<template>
    <v-container fill-height class="main-container">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5">
          <v-card class="pa-6 border-top-gold-6 text-center" rounded="xl">
            <h2 class="mb-2 font-playfair">Thank You!</h2>
            <div class="subtitle-1 mb-4 text-gold">Your registration is successful!</div>

            <div class="mb-4 grey--text text--darken-1">
              ✦ Your Digital Passport is ready! ✦
            </div>
            <p>Scan this QR code at the event entrance to access your passport, collect stamps, and enjoy exclusive perks.</p>
            <!-- QR CODE -->
            <div class="d-flex justify-center">
                <div class="px-3 border-gold-2 border-radius-10">
                    <v-img
                    :src="qrCodeUrl"
                    contain
                    max-width="200"
                    class="mx-auto my-4"
                    ></v-img>
                </div>
            </div>

            <div class="bg-primary pa-2 border-radius-10 mt-5">
                <small class="text-gold-300">YOUR LIVE ID</small>
                <div class="white--text">{{ details.live_id }}</div>
            </div>

            <div class="d-flex justify-center">
                <div class="panel pa-3 mt-5 d-flex justify-center align-center">
                    <v-icon large>mdi-cellphone-wireless</v-icon>
                    <div class="text-sm grey--text">Show this QR code at the event entrance and at exhibitor booths to collect stamps and win prizes!</div>
                </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div>
                <div>POWERED BY</div>
                <img src="@/assets/passport-banner/live-album-logo.png" height="60" alt="">
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>
<script>
import api from '@/services/axios';

export default {
  data() {
    return {
        details : {}
    };
  },
  computed: {
    qrCodeUrl() {
        let link = process.env.VUE_APP_BASE_URL + '/event-attendance/' + this.details.registration_code;
        return `${process.env.VUE_APP_API_URL}/event-registration/qr?link=${link}`
    },
  },
  mounted() {
    let code = this.$route.params.code;
    api.get(`/event-registration/details/${code}`).then((res) => {
        this.details = res.data;
    });
  }
};
</script>
<style scoped>
body {
    background-color: #ffefcc;
}

.ticket-card {
  background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(12px);
    color: white;
}

.v-parallax {
  position: relative;
}

.ticket-card {
  animation: float 5s ease-in-out infinite;
}
.border-top-gold-6 {
    border-top: 5px solid goldenrod !important;
}
.border-gold {
    border: 1px solid #94742b;
}
.border-gold-2 {
    border: 2px solid goldenrod;
}
.text-gold {
    color: #94742b;
}
.text-gold-300 {
    color: #ffc848;
}
.font-playfair {
    font-family: 'Playfair Display', serif;
    font-style: italic;
    font-size: 2rem;
    line-height: 1.1;
}
.border-radius-10 {
    border-radius: 10px;
}
.bg-primary {
    background-color: #1a3765;
}
.text-sm {
    font-size: 14px;
}
.panel {
    border: 1px solid #858585;
    border-radius : 10px;
}
</style>